import * as yup from 'yup'

export const bodApproveSchema = yup.object().shape({
    day_off_feedback_bod: yup.string().required('Please feedback'),
})
